import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowTopLeftCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowTopLeftCorner"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 13H9V10.4141L13 14.4141L14.4141 13L10.4141 9H13V7H7V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowTopLeftCorner;
